/**
 * @name BackupLogDialog
 * @description Modal para visualizar los comentarios de un backup
 * @author Gerardo de León
 */

import React, { Component } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';

import CommentLog from './comment-log';
import BadgeStatus from './badge-status';
import { AppDetail } from '@components';

import { Icons, Layout, MUI, Typography, Flex, Unicons, Theme, Avatar } from '@styles';

class BackupLogDialog extends Component {
    constructor(props) {
        super(props);
        this.userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empleado;
        this.state = {
        };
    }

    componentDidMount() {
    }

    render() {
        const { open, onClose, comments } = this.props;

        const getResponsabilityLabel = (typeAction) => {
            switch (typeAction) {
                case 1: return i18n.t('BackupSettings.catalogResp1');
                case 2: return i18n.t('BackupSettings.catalogResp2');
                case 3: return i18n.t('BackupSettings.catalogResp3');
                case 4: return i18n.t('BackupSettings.catalogResp4');
                case 5: return i18n.t('BackupSettings.catalogResp5');
                default: break;
            }
        };

        return (
            <MUI.Dialog
                open={open}
                onClose={onClose}
                maxWidth="md"
                disableBackdropClick
            >
                <MUI.DialogTitle>
                    {/* ID Actividad & Estatus*/}
                    <Flex.Col flex="1" style={{ marginLeft: '16px' }}>
                        <Typography.H5>{i18n.t('BackupSettings.backupLog')}</Typography.H5>
                        <Flex.Row>
                            <BadgeStatus statusId={comments.IdEstatus} />
                        </Flex.Row>
                    </Flex.Col>
                    {/* Comentarios & Archivos Adjuntos */}
                    <Flex.Row style={{ marginRight: '20px' }}>
                        <Unicons.Comment size="20" color={Theme.colors.greyDark} style={{ marginRight: '8px' }} />
                        <Typography.H5>{comments.Comentarios.length}</Typography.H5>
                        <MUI.Divider orientation="vertical" margin="0 16px" style={{ height: '30px' }} />
                    </Flex.Row>
                    <MUI.DialogBoxClose onClick={onClose}>
                        <Icons.Close />
                    </MUI.DialogBoxClose>
                </MUI.DialogTitle>


                <MUI.DialogContent style={{ padding: '0px' }}>
                    <MUI.Grid container>
                        {/* -- INFO DE LA ACTIVIDAD -- */}
                        <MUI.Grid item sm={5} xs={12}>
                            <Styled.FlexActivityInfo>
                                {/* Actividad */}
                                <Flex.Col padding="8px">
                                    <Typography.Text>
                                        <Typography.Medium>{`${i18n.t('BackupSettings.requestDescription')}:`}</Typography.Medium>
                                    </Typography.Text>
                                </Flex.Col>
                                {/* Creada por | Entrevistador */}
                                <Flex.Row padding="8px">
                                    <Avatar size="xs" src={comments.FotoApoyoBackup ? comments.FotoApoyoBackup : 'https://assets.talentry.io/icons/profile/TAL_Avatar.png'} />
                                    <Flex.Col style={{ marginLeft: '16px' }}>
                                        <Typography.Text>{comments.Nombre}</Typography.Text>
                                        <Typography.Small color="greyDarkAlpha">{i18n.t('BackupSettings.aplicantBackup')}</Typography.Small>
                                    </Flex.Col>
                                </Flex.Row>
                                {/* Generada para | Entrevistado */}
                                <Flex.Row padding="8px">
                                    <Avatar size="xs" src={comments.FotoBackup ? comments.FotoBackup : 'https://assets.talentry.io/icons/profile/TAL_Avatar.png'} />
                                    <Flex.Col style={{ marginLeft: '16px' }}>
                                        <Typography.Text>{comments.NombreBackup}</Typography.Text>
                                        <Typography.Small color="greyDarkAlpha">{i18n.t('Backup')}</Typography.Small>
                                    </Flex.Col>
                                </Flex.Row>
                                <MUI.Divider color="greyHover" margin="16px 8px" />
                                {/* Fecha inicio */}
                                <Flex.Row padding="8px">
                                    <Styled.BoxIcon28><Unicons.Calendar size="28" color={Theme.colors.greyDark} /></Styled.BoxIcon28>
                                    <Flex.Col>
                                        <Typography.Small><Typography.Medium>{`${i18n.t('GenericMessages.startDate')}: `}</Typography.Medium></Typography.Small>
                                        <Flex.Row>
                                            <Typography.Text>{moment(comments.FechaInicio).format(`DD MMM YYYY`)}</Typography.Text>
                                        </Flex.Row>
                                    </Flex.Col>
                                </Flex.Row>
                                {/* Fecha fin */}
                                <Flex.Row padding="8px">
                                    <Styled.BoxIcon28><Unicons.Calendar size="28" color={Theme.colors.greyDark} /></Styled.BoxIcon28>
                                    <Flex.Col>
                                        <Typography.Small><Typography.Medium>{`${i18n.t('GenericMessages.endDate')}: `}</Typography.Medium></Typography.Small>
                                        <Flex.Row>
                                            <Typography.Text>{moment(comments.FechaFin).format(`DD MMM YYYY`)}</Typography.Text>
                                        </Flex.Row>
                                    </Flex.Col>
                                </Flex.Row>
                                {/* Responsabilidades */}
                                <Flex.Row padding="8px">
                                    <Styled.BoxIcon28>
                                        {comments.IdResponsabilidades[0].IdResponsabilidad < 5 && (
                                            <AppDetail
                                                app={'https://assets.talentry.io/icons/appicons/metrics.png'}
                                                appSize={'xxs'}
                                            />
                                        )}
                                        {comments.IdResponsabilidades[0].IdResponsabilidad > 4 && (
                                            <AppDetail
                                                app={'https://assets.talentry.io/icons/appicons/helpcenter.png'}
                                                appSize={'xxs'}
                                            />
                                        )}

                                    </Styled.BoxIcon28>
                                    <Flex.Col>
                                        <Typography.Small><Typography.Medium>{`${i18n.t('GenericMessages.responsibilities')}: `}</Typography.Medium></Typography.Small>
                                        {comments.IdResponsabilidades.map((comment, i) => (
                                            <Typography.Text key={i}>{i + 1}{' - '}{getResponsabilityLabel(comment.IdResponsabilidad)}</Typography.Text>
                                        ))}
                                    </Flex.Col>
                                </Flex.Row>
                                <MUI.Divider color="greyHover" margin="16px 8px" />
                            </Styled.FlexActivityInfo>
                        </MUI.Grid>
                        <MUI.Grid item sm={7} xs={12}>
                            <Styled.FlexActivityLog>
                                <Styled.FlexComments>
                                    {(comments.Comentarios && comments.Comentarios.length !== 0) && (
                                        <>
                                            {comments.Comentarios.map((item, index) => {
                                                return (
                                                    <CommentLog
                                                        key={index}
                                                        photo={item.FotoComentario}
                                                        name={item.NombreComentario}
                                                        date={item.Fecha}
                                                        comment={item.Comentario}
                                                        estatus={item.IdEstatus}
                                                    />
                                                );
                                            })}
                                        </>
                                    )}
                                </Styled.FlexComments>
                            </Styled.FlexActivityLog>

                        </MUI.Grid>
                    </MUI.Grid>
                </MUI.DialogContent >

                <MUI.DialogActions>
                    <MUI.ButtonText onClick={onClose}>
                        {i18n.t('DialogConfirm.cancel')}
                    </MUI.ButtonText>
                </MUI.DialogActions>

            </MUI.Dialog >
        );
    }
}

BackupLogDialog.propTypes = {
    // Boolean que indica si el modal esta abierto.
    open: PropTypes.bool.isRequired,
    // Función que se ejecuta cuando se cierra el modal.
    onClose: PropTypes.func.isRequired,
    // Objeto de comentarios del backup seleccionado.
    comments: PropTypes.object
};

// *************************************
// STYLED COMPONENTS
// *************************************

const Styled = {};

Styled.BoxSwitch = styled.div`
  width: 100%;
  padding: 8px;
`;

Styled.FlexActivityInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 212px);
  background-color: ${(props) => props.theme.colors.white};
  border-right: 1px solid ${(props) => props.theme.colors.greyLight};
  overflow-y: auto;
  scrollbar-width: thin !important; /* Scrollbar Firefox */
  @media (max-width: 600px) { overflow-y: hidden; }
`;

Styled.BoxIcon28 = styled.div`
  width: 28px;
  height: 28px;
  min-width: 28px;
  min-height: 28px;
  margin-right: 8px;
`;

Styled.FlexActivityLog = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 212px);
  background-color: ${(props) => props.theme.colors.white};
  overflow-y: clip;
`;

Styled.FlexComments = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  height: 100%;
  min-height: 100px;
  overflow-y: auto;
  scrollbar-width: thin !important; /* Scrollbar Firefox */
  background-color: ${(props) => props.theme.colors.white};
  @media (max-width: 600px) { overflow-y: hidden; }
`;

export default BackupLogDialog;
